import React, { useEffect, useRef } from "react";
import { useSaveGame, useUpdateGame } from "@seabrookstudios/pitch2table";
import { importNestifyzGame } from "./importNestifyzGame";

/**
 * Creates a Pitch2Table game from a NestiFyz export entry.
 *
 * @param {object} props
 * @param {import("./parseExport").NestiFyzGame} props.game
 * @param {(gameId: import("@seabrookstudios/types").GameId) => void} props.onReady
 * @param {() => void} props.onError
 */
export const NestiFyzGameCreateFlow = ({ game, onReady, onError }) => {
  const saveGame = useSaveGame();
  const updateGame = useUpdateGame();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) {
      return;
    }

    started.current = true;

    importNestifyzGame(game, {
      saveGame: saveGame.mutateAsync.bind(saveGame),
      updateGame: updateGame.mutateAsync.bind(updateGame),
    })
      .then(({ gameId }) => {
        onReady(gameId);
      })
      .catch(() => {
        onError();
      });
  }, [game, onError, onReady, saveGame, updateGame]);

  return null;
};
